import React from 'react';
import { Spinner } from '@volkswagen-onehub/components-core';

import ContentList from '../../../../shared/components/content-list';
import {
  StyledCardsContainer,
  StyledInformationContainer,
  StyledSpinnerContainer,
  StyledUserSubscriptionsContainer,
  StyledUserVehiclesAndServicesContainer,
  StyledUserVehiclesContainer,
} from './styled';
import ContentListItem from '../../../../shared/components/content-list-item';
import { InformationBox } from '../../../../shared/components/information-box/InformationBox';
import { SubscriptionCard } from '../../../../shared/components/subscription-card/SubscriptionCard';
import { CompleteVehicleCard } from '../../../../shared/components/vehicle-card/complete-vehicle-card/CompleteVehicleCard';
import {
  Plan,
  SiriusXMSubscription,
  Vehicles,
} from '../../../../shared/typings/main';
import { getPreferredVehicle } from '../../../../shared/utils/general';

interface RemoveVehiclePrimaryRole {
  translationHandler: (key: string) => string;
  userVehicles: Vehicles[];
  externalSubscriptions: any[];
  deactivateButtons: Function;
  hasSiriusXMSubscription?: SiriusXMSubscription;
}

const RemoveVehiclePrimaryRole = ({
  translationHandler,
  userVehicles = [],
  externalSubscriptions,
  deactivateButtons,
  hasSiriusXMSubscription,
}: RemoveVehiclePrimaryRole) => {

  const preferredVehicle = getPreferredVehicle(userVehicles);

  return (
    <StyledUserVehiclesAndServicesContainer>
      <ContentList
        title={translationHandler(
          'vehicleManagement.removeVehicle.primary.title',
        )}
      >
        <ContentListItem>
          {translationHandler(
            'vehicleManagement.removeVehicle.primary.firstContent',
          )}
        </ContentListItem>
        <ContentListItem>
          {translationHandler(
            'vehicleManagement.removeVehicle.primary.secondContent',
          )}
        </ContentListItem>
      </ContentList>
      <StyledUserVehiclesContainer>
        <StyledInformationContainer>
          <InformationBox
            title={translationHandler(
              'vehicleManagement.removeVehicle.lose.title',
            )}
          />
        </StyledInformationContainer>
        <StyledCardsContainer hasDescription={false}>
          {!preferredVehicle ? (
            <StyledSpinnerContainer>
              <Spinner />
            </StyledSpinnerContainer>
          ) : (
            <CompleteVehicleCard
              id={preferredVehicle!.vehicleId}
              vehicle={preferredVehicle}
              translationHandler={translationHandler}
              {...{ fromRemoveVehicle: true }}
            />
          )}
        </StyledCardsContainer>
      </StyledUserVehiclesContainer>
      {(externalSubscriptions.length > 0 || hasSiriusXMSubscription) && (
        <StyledUserSubscriptionsContainer>
          <StyledInformationContainer>
            <InformationBox
              title={translationHandler(
                'vehicleManagement.removeVehicle.services.title',
              )}
              description={translationHandler(
                'vehicleManagement.removeVehicle.services.subscriptions.description',
              )}
            />
          </StyledInformationContainer>
          <StyledCardsContainer hasDescription={true}>
            {externalSubscriptions.map((subscription: Plan, index: number) => (
              <SubscriptionCard
                id={`${subscription.package.sku || index + 1}`}
                planName={subscription.package.name || ''}
                providerName={subscription.provider.name || ''}
                translationHandler={translationHandler}
              />
            ))}
            {hasSiriusXMSubscription && (
              <SubscriptionCard
                id="SiriusXM-Subscription-Card"
                planName="SiriusXM"
                providerName="SiriusXM"
                translationHandler={translationHandler}
              />
            )}
          </StyledCardsContainer>
        </StyledUserSubscriptionsContainer>
      )}
      {deactivateButtons()}
    </StyledUserVehiclesAndServicesContainer>
  );
};

export default RemoveVehiclePrimaryRole;
